import { Component } from '@angular/core';
import {
  Data, Subscription, PriceCalculationService,SummaryService,
  DataLoaderService, ProgressBarService, CommonDataService
} from '../expert-screen-components/expert-service-call.index';


@Component({
  selector: 'error-overlay',
  templateUrl: './error-overlay.template.html',
  styleUrls: ['./error-overlay.component.css'],
})
export class ErrorOverlay {
  constructor(private dataLoaderService: DataLoaderService){

  }
  close(){

    (<HTMLInputElement>document.getElementById('RETCODEID')).value = '0';
    (<HTMLInputElement>document.getElementById('acceptString')).value = '0';
    (<HTMLFormElement>document.getElementById('form1')).action = this.dataLoaderService.vehicleInfo.hookURL + '';
    (<HTMLFormElement>document.getElementById('form1')).submit();
  }
}


// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/error-overlay/error-overlay.component.ts